import React from 'react';
export default class CustomForm extends React.Component {
    constructor(args) {
        super(args);
        this.validators = {};
        this.fields = {};
        this.state = {
            fields: {}
        };
    }

    //Setter method add component and validator to Validator Registry
    registerField = (componentName, validationFunctions, value) => {
        //Validators return obj{valid:bool[, errors:[String]] }
        if (!this.validators[componentName]) {
            this.validators[componentName] = [];
        }
        this.validators[componentName].push(...validationFunctions);
        const fields = this.state.fields;
        fields[componentName] = {};
        fields[componentName].value = value;
        this.setState({ fields: fields });
    };

    //Runs all the validators on a specific component
    runValidation = (componentName, componentValue) => {
        const errors = [];
        console.log('Validators', this.validators[componentName]);
        if (!this.validators[componentName]) return errors;

        this.validators[componentName].forEach(validator => {
            const result = validator(componentValue);
            console.log('Ran Validator', result);
            if (!result.valid && result.errors) {
                errors.push(...result.errors);
            }
        });
        console.log('THESE ARE JUST THE ERRORS FOUND', errors);
        return errors;
    };

    //Run all validators of all fields
    runAllValidation = () => {
        //get keys of all registered fields
        //loop through keys to one by one runValidation
        //update errors on field
        const allErrors = [];
        const fieldsList = Object.keys(this.state.fields);
        const fields = this.state.fields;
        fieldsList.forEach(field => {
            const componentName = field;
            const componentValue = this.state.fields[field].value;

            const errors = this.runValidation(componentName, componentValue);
            console.log(
                'RAN VALIDATION',
                componentName,
                componentValue,
                errors
            );
            fields[componentName] = {
                errors: errors,
                value: componentValue
            };

            allErrors.push(...errors);
        });

        this.setState({ fields: fields });
        console.log('THIES ARE ALL THE MFN ERRORS', allErrors);
        return allErrors;
    };

    //Handles the Onlick event
    handleOnclick = event => {};

    //TODO: Run validation blur instead of change. On change will mark the field wrong before
    //the user has completed the input. Conversly, we could run on change to track errors, and then only
    //apply them onSubmit
    handleOnChange = event => {
        console.log('CAHNGES WILL COME');
        const componentName = event.target.name;
        const componentValue = event.target.value;
        const errors = this.runValidation(componentName, componentValue);
        const fields = this.state.fields;

        fields[componentName] = {
            errors: errors,
            value: componentValue
        };
        this.setState({ fields: fields });
    };

    isFormValid() {
        //run all validator
        const errors = this.runAllValidation();
        return !errors.length > 0;
    }
    serializeForm = () => {
        const form = {};
        const fields = Object.keys(this.state.fields);
        fields.forEach(field => {
            form[field] = this.state.fields[field].value;
        });
        return form;
    };
}



// WEBPACK FOOTER //
// ./src/modules/form/components/custom-form/CustomForm.jsx